/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */
import React, { useState, useMemo, useRef } from 'react';
import { groupBy } from 'lodash-es';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import Icon from '../../../../../../../components/Icon';
import Slider from '../../../../../components/Slider';
import AllNfDrawer from './components/AllNfListDrawer';

import {
  Container,
  Header,
  HeaderText,
  TabContainer,
  TabButton,
  SliderContainer,
  SectionContainer,
  SliderCardWrapper,
  SliderTitle,
  InfoWrapper,
  SliderInfo,
  ContentContainer,
  ContentWrapper,
  NfContainer,
  NfId,
  DriverInfoContainer,
  Tooltip,
  DestinationName,
  FooterInfoTypography,
  FooterInfoContainer,
  InfoTitle,
  ChipContainer,
  DriverInfoWrapperSecondary,
  FileImage,
  StyledKeyboardArrowRight,
} from './styles';
import DeliverySection from './components/DeliverySection';
import DriverSection from './components/DriverSection';
import { Route } from '@mui/icons-material';
import {
  PERFORMANCE_COLORS,
  PERFORMANCE_ENUM_TRANSKEY,
  returnScheduledTranskey,
  returnScheduledColor,
} from '../../../../../../../enums/performance-enum';
import FileSignatureWhite from '../../../../../../../assets/images/file-signature-white.png';
import FileSignatureBlue from '../../../../../../../assets/images/file_signature-blue.png';

const DeliveryModal = ({ nfData, onClose, initialSlide }) => {
  const [currentSlideState, setCurrentSlideState] = useState(
    initialSlide !== undefined && initialSlide !== null ? initialSlide : 0,
  );
  const [byNf, setByNf] = useState(false);
  const [nfDetail, setNfDetail] = useState({
    isVisible: false,
    data: null,
  });

  const listByDestination = useMemo(() => {
    const nfByDestination = groupBy(nfData, 'destination.address');
    return Object.values(nfByDestination);
  }, [nfData]);

  const lastInitialSlideRef = useRef(initialSlide);
  const lastNfDataRef = useRef(nfData);

  const hasExternalChange =
    (initialSlide !== undefined &&
      initialSlide !== null &&
      lastInitialSlideRef.current !== initialSlide) ||
    lastNfDataRef.current !== nfData;

  if (hasExternalChange) {
    if (
      initialSlide !== undefined &&
      initialSlide !== null &&
      lastInitialSlideRef.current !== initialSlide
    ) {
      setCurrentSlideState(initialSlide);
      lastInitialSlideRef.current = initialSlide;
    }
    lastNfDataRef.current = nfData;
  }

  const nfList = useMemo(() => {
    if (listByDestination?.length === 0) {
      return [];
    }
    const slideIndex =
      currentSlideState >= 0 && currentSlideState < listByDestination?.length
        ? currentSlideState
        : 0;
    return listByDestination?.[slideIndex] || listByDestination?.[0] || [];
  }, [listByDestination, currentSlideState]);

  const driverInfo =
    nfList && nfList !== undefined && nfList?.length > 0
      ? nfList[0]
      : {
          nomeMotorista: '-',
          tms: {
            placaCarreta: '-',
            expectedDate: '-',
            scheduled: false,
            progress: {
              lastStatusDate: '-',
            },
          },
          destination: {
            address: '-',
            destination: '-',
            city: '-',
          },
          shippingCompany: {
            corporateName: '-',
            cnpj: '-',
            icon: '-',
          },
          cpfMotorista: '-',
          placaCavalo: '-',
        };

  return (
    <Container>
      <Header>
        <HeaderText>Documentos e informações da entrega</HeaderText>
        <Icon name="close" onClick={onClose} />
      </Header>

      <TabContainer>
        <TabButton
          active={!byNf}
          onClick={() => {
            setByNf(false);
            setNfDetail({
              isVisible: false,
              data: null,
            });
          }}
        >
          <Route />
          {`Destinatário (${listByDestination.length})`}
        </TabButton>
        <TabButton active={byNf} onClick={() => setByNf(true)}>
          <img src={FileSignatureBlue} alt="Icon" width={24} height={24} />
          {`Nota fiscal (${nfData.length})`}
        </TabButton>
      </TabContainer>

      <ContentContainer>
        <AllNfDrawer
          show={byNf}
          nfDetail={nfDetail}
          setNfDetail={setNfDetail}
          nfList={nfData}
        />
        <SliderContainer>
          <SliderTitle>Destinatário</SliderTitle>
          <Slider
            sliderType=""
            listLength={listByDestination.length}
            initialSlide={initialSlide}
            onChangeSlide={currentSlide => {
              setCurrentSlideState(currentSlide);
            }}
            footerInfo={currentSlide => (
              <FooterInfoContainer>
                <FooterInfoTypography>{`Entrega ${currentSlide}/${listByDestination.length}`}</FooterInfoTypography>
                <DriverInfoWrapperSecondary>
                  <ChipContainer
                    backgroundColor={PERFORMANCE_COLORS[driverInfo.performance]}
                  >
                    <InfoTitle
                      small
                      color="#FFF"
                      style={{ marginBottom: 0 }}
                    >{`${
                      PERFORMANCE_ENUM_TRANSKEY[driverInfo.performance]
                    }`}</InfoTitle>
                  </ChipContainer>
                  <InfoTitle
                    uppercase
                    small
                    bold
                    color="#FFF"
                    backgroundColor={returnScheduledColor(
                      driverInfo.tms.scheduled,
                    )}
                  >
                    {returnScheduledTranskey(driverInfo.tms.scheduled)}
                  </InfoTitle>
                </DriverInfoWrapperSecondary>
              </FooterInfoContainer>
            )}
          >
            {listByDestination.map((el, id) => (
              <SliderCardWrapper
                key={`${el[0].destination.name}-${el[0].cnpjDest}-${id}`}
              >
                <InfoWrapper>
                  <SliderInfo>
                    <DestinationName>{el[0].destination.name}</DestinationName>
                  </SliderInfo>
                  <SliderInfo>
                    <DestinationName>{el[0].cnpjDest}</DestinationName>
                  </SliderInfo>
                </InfoWrapper>
              </SliderCardWrapper>
            ))}
          </Slider>
        </SliderContainer>

        <DeliverySection driverInfo={driverInfo} />
        <SectionContainer
          borderBottom
          borderTop
          borderBottomColor="#EEEEEE"
          borderTopColor="#EEEEEE"
        >
          <DriverInfoContainer>
            <SliderTitle flex noMargin>
              Notas fiscais
            </SliderTitle>
          </DriverInfoContainer>
          <ContentWrapper flex>
            {nfList &&
              nfList.map(el => (
                <NavLink
                  to={`/u/tracking/${el.nf}`}
                  style={{ textDecoration: 'none', width: '100%' }}
                  key={`${el.nf}-${el.nfGroup}`}
                >
                  <NfContainer>
                    <FileImage src={FileSignatureWhite} alt="File icon" />
                    <NfId>{`${el.nf}-${el.nfGroup}`}</NfId>
                    <StyledKeyboardArrowRight />
                  </NfContainer>
                </NavLink>
              ))}
          </ContentWrapper>
        </SectionContainer>
        <DriverSection driverInfo={driverInfo} onlyShipping />
      </ContentContainer>
    </Container>
  );
};

const mapStateToProps = state => ({ userType: state.auth.userType });

export default connect(mapStateToProps)(DeliveryModal);
